import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '../lib/api.js';
import { useAuthStore } from '../stores/auth.js';

import type { TenantTypeCode } from '@axioma/shared';

interface MeResponse {
  user: {
    id: string;
    email: string;
    name: string;
    twoFactorEnabled: boolean;
    oabNumber: string | null;
    oabState: string | null;
  };
  currentTenantId: string | null;
  tenants: Array<{ id: string; name: string; slug: string; type: TenantTypeCode; role: string }>;
}

export function useAuthBootstrap(): void {
  const token = useAuthStore((s) => s.token);
  const setProfile = useAuthStore((s) => s.setProfile);

  const enabled = Boolean(token);
  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      const { data } = await api.get<MeResponse>('/auth/me');
      return data;
    },
    enabled,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (query.data) {
      setProfile(query.data);
    }
  }, [query.data, setProfile]);
}
